import React from 'react';
import { Box, Typography, Grid, Paper, Card, CardContent } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export default function Dashboard() {
  const [uptimeData, setUptimeData] = React.useState(null);
  const [statistics, setStatistics] = React.useState([]);

//  React.useEffect(() => {
//    // Fetch uptime statistics
//    fetch('/api/public/uptime/statistics', { credentials: 'include' })
//      .then(res => res.json())
//      .then(data => {
//        setUptimeData(data);
//        setStatistics(data);
//      })
//      .catch(err => console.error('Failed to fetch uptime data:', err));
//  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>

      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Average Uptime
              </Typography>
              <Typography variant="h3">
                {statistics && statistics.length > 0
                  ? (statistics.reduce((sum, s) => sum + (s.uptime_percentage || 0), 0) / statistics.length).toFixed(2)
                  : '0'}%
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Services Up
              </Typography>
              <Typography variant="h3" sx={{ color: '#4caf50' }}>
                {statistics ? statistics.filter(s => s.available).length : 0} / {statistics ? statistics.length : 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Services Down
              </Typography>
              <Typography variant="h3" sx={{ color: '#f44336' }}>
                {statistics ? statistics.filter(s => !s.available).length : 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Service Availability (Last 3 Days)
            </Typography>
            {statistics && statistics.length > 0 ? (
              <ResponsiveContainer width="100%" height={400}>
                <LineChart
                  data={statistics.map(stat => ({
                    name: stat.service_url?.replace(/^https?:\/\//, '').substring(0, 30) || 'Unknown',
                    availability: stat.uptime_percentage || 0,
                    checks: stat.total_checks || 0
                  }))}
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" angle={-45} textAnchor="end" height={100} />
                  <YAxis domain={[0, 100]} label={{ value: 'Availability %', angle: -90, position: 'insideLeft' }} />
                  <Tooltip
                    formatter={(value, name) => {
                      if (name === 'availability') return `${value.toFixed(2)}%`;
                      return value;
                    }}
                    labelFormatter={(label) => `Service: ${label}`}
                  />
                  <Legend />
                  <Line
                    type="monotone"
                    dataKey="availability"
                    stroke="#8884d8"
                    strokeWidth={2}
                    name="Uptime %"
                    activeDot={{ r: 8 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No uptime data available
              </Typography>
            )}
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Service Status Details
            </Typography>
            {statistics && statistics.length > 0 ? (
              <Box sx={{ mt: 2 }}>
                {statistics.map((stat, idx) => (
                  <Box key={idx} sx={{ mb: 2, pb: 2, borderBottom: idx < statistics.length - 1 ? '1px solid #e0e0e0' : 'none' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                      {stat.service_url}
                    </Typography>
                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">
                          Status: <span style={{ color: stat.available ? '#4caf50' : '#f44336', fontWeight: 'bold' }}>
                            {stat.available ? 'UP' : 'DOWN'}
                          </span>
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">
                          Uptime: {stat.uptime_percentage?.toFixed(2) || 0}%
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">
                          Total Checks: {stat.total_checks || 0}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">
                          Last Check: {stat.last_check ? new Date(stat.last_check).toLocaleString() : 'N/A'}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                ))}
              </Box>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No services configured
              </Typography>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

